import React from "react";
import styled from "styled-components";
//
import Article from "./article";
//

export default ({ items, ...rest }) => (
  <Wrap>
    <List>
      {items.map((items, i) => (
        <Article key={i} {...items} />
      ))}
    </List>
  </Wrap>
);
//
const Wrap = styled.div`
  @media (min-width: 769px) {
    padding-right: 250px;
  }
`;

const List = styled.div`
  padding: 1rem 0.5rem;

  @media (min-width: 769px) {
    padding: 1rem 5rem;
  }
`;
